import {
	USER_ADDRESS,
	USER_DOCUMENTS,
	UPDATE_USER_DOCUMENT,
	USER_VECHICLES,
	UPDATE_USER_VEHICLE,
	UPDATE_VEHICLE_DEFAULT_ADDRESS,
	USER_CUR_LAT_LONG,
	USER_MAP_ADDRESS,
	DELETE_VEHICLE,
	DELETE_ADDRESS,
	STORE_CITY_STATE,
	EDIT_ADDRESS_ID,
	EDIT_USER_ADDRESS,
	GET_RECOMMENDED_SERVICES,
	GET_RECOMMENDED_SERVICES_SUCCESS,
	GET_RECOMMENDED_SERVICES_FAILED,
	FORM_CAR_SLIDE_DATA,
	WITH_SEARCH_RECOMMENDATIONS,
	WITH_SEARCH_RECOMMENDATIONS_SUCCESS,
	WITH_SEARCH_RECOMMENDATIONS_FAILED,
	GET_FAQS,
	GET_FAQS_SUCCESS,
	GET_FAQS_FAILED,
	SAVE_SEARCH_SERVICE_DATA,
	SAVE_CATELOG_VEHICLE_ID,
	SAVE_ADDRESS_DID_REF,
	GET_SERVICE_DETAILS,
	GET_SERVICE_DETAILS_SUCCESS,
	GET_SERVICE_DETAILS_FAILED,
	SAVE_LOCATION_STATUS,
	LOGOUT_SUCCESS,
	SAVE_USER_VEHICLES,
	GET_USER_REFERAL_DETAILS,
	GET_USER_REFERAL_DETAILS_SUCCESS,
	GET_USER_REFERAL_DETAILS_FAILED,
	SAVE_USER_REFERAL,
	SAVE_USER_REFERAL_SUCCESS,
	SAVE_USER_REFERAL_FAILED,
	GET_VEHICLE_PERSPECTIVES,
	GET_VEHICLE_IMAGE,
	GET_VEHICLE_IMAGE_SUCCESS,
	GET_VEHICLE_IMAGE_FAILED,
	GET_APP_VERSIONS,
	GET_APP_VERSIONS_SUCCESS,
	GET_APP_VERSIONS_FAILED,
} from "../Types";
import { CALL_API } from "../api.middleware";
import { CLIENT_NAME } from "../../constants";

export const userAddress = (payload) => {
	return {
		data: payload,
		type: USER_ADDRESS,
	};
};

export const userDocuments = (payload) => {
	return {
		data: payload,
		type: USER_DOCUMENTS,
	};
};

export const getStoreAppVersions = () => async (dispatch) => {
	try {
		return await dispatch({
			[CALL_API]: {
				url: `/settings/global-settings?clientName=${CLIENT_NAME}`, // "/workshopManagement/getCurrentAppVersion",
				method: "GET",
				types: [GET_APP_VERSIONS, GET_APP_VERSIONS_SUCCESS, GET_APP_VERSIONS_FAILED],
				showLoader: true,
				otherUrl: false,
				secondaryUrl: false, // false for prod --- true for UAT
				additionalData: {
					showError: false,
				},
			},
		});
	} catch (error) {
		alert("B86 = " + `${error}`);
	}
};

export const getVehicleImage = (modelName, catalogVehicleId) => async (dispatch) => {
	try {
		return await dispatch({
			[CALL_API]: {
				url: `/catalog/models?model=${modelName}&catalogVehicleId=${catalogVehicleId}&clientName=${CLIENT_NAME}`,
				method: "GET",
				types: [GET_VEHICLE_IMAGE, GET_VEHICLE_IMAGE_SUCCESS, GET_VEHICLE_IMAGE_FAILED],
				showLoader: true,
			},
		});
	} catch (error) {
		// alert(`${error}`);
		console.error("UInfo - 79", error);
	}
};

export const userVehicles = (payload, operationType = "merge") => {
	return {
		data: payload,
		type: USER_VECHICLES,
		operationType: operationType,
	};
};

export const saveUserVehicles = (payload) => {
	return {
		data: payload,
		type: SAVE_USER_VEHICLES,
	};
};

export const updateUserDocuments = (payload) => {
	return {
		data: payload,
		type: UPDATE_USER_DOCUMENT,
	};
};

export const updateUserVehicleDocuments = (id, payload) => {
	return {
		data: payload,
		id,
		type: UPDATE_USER_VEHICLE,
	};
};
export const storeUserMapAddress = (address) => {
	return {
		map_address: address,
		type: USER_MAP_ADDRESS,
	};
};

export const storeCurrentLatLong = (lat, long) => {
	return {
		curLat: lat,
		curLong: long,
		type: USER_CUR_LAT_LONG,
	};
};
export const updateVehicleDefaultAddress = (payload) => {
	return {
		data: payload,
		type: UPDATE_VEHICLE_DEFAULT_ADDRESS,
	};
};

export const deleteVehicle = (payload) => {
	return {
		data: payload,
		type: DELETE_VEHICLE,
	};
};

export const deleteAddress = (payload) => {
	return {
		data: payload,
		type: DELETE_ADDRESS,
	};
};

export const storeCityAndState = (stateCity) => {
	return {
		data: stateCity,
		type: STORE_CITY_STATE,
	};
};

export const storeUserEditAddressId = (addId) => {
	return {
		id: addId,
		type: EDIT_ADDRESS_ID,
	};
};

export const editParticularAddress = (payload) => {
	return {
		edit_add: payload,
		type: EDIT_USER_ADDRESS,
	};
};

export const storeCarSlidesData = (vehicleList, modelData) => {
	return {
		vehicle_list: vehicleList,
		model_data: modelData,
		type: FORM_CAR_SLIDE_DATA,
	};
};

export const getRecommendedServices =
	(params = {}) =>
	async (dispatch) => {
		try {
			return await dispatch({
				[CALL_API]: {
					url: "/catalog/services/search",
					method: "GET",
					types: [
						GET_RECOMMENDED_SERVICES,
						GET_RECOMMENDED_SERVICES_SUCCESS,
						GET_RECOMMENDED_SERVICES_FAILED,
					],
					showLoader: true,
					params,
				},
			});
		} catch (error) {
			// alert(`${error}`);
			console.error("UInfo - 169", error);
		}
	};

// export const withSearchGetRecommendations = () => async (dispatch) => {
// 	try {
// 		return await dispatch({
// 			[CALL_API]: {
// 				url: `/catalog/services/search?catalogVehicleId=1234&searchString="brake"`,
// 				method: "GET",
// 				types: [
// 					WITH_SEARCH_RECOMMENDATIONS,
// 					WITH_SEARCH_RECOMMENDATIONS_SUCCESS,
// 					WITH_SEARCH_RECOMMENDATIONS_FAILED,
// 				],
// 			},
// 		});
// 	} catch (error) {
// 		// alert(`${error}`);
// 		console.error("UInfo - 188", error);
// 	}
// };

export const getFaqs = (faqId) => async (dispatch) => {
	try {
		return await dispatch({
			[CALL_API]: {
				url: `/catalog/faqs?faqListId=${faqId}&clientName=${CLIENT_NAME}`,
				method: "GET",
				types: [GET_FAQS, GET_FAQS_SUCCESS, GET_FAQS_FAILED],
				showLoader: true,
			},
		});
	} catch (error) {
		// alert(`${error}`);
		console.error("UInfo - 204", error);
	}
};
export const saveServiceSearchData = (payload) => {
	return {
		data: payload,
		type: SAVE_SEARCH_SERVICE_DATA,
	};
};

export const saveCatelogVehicleId = (payload) => {
	return {
		data: payload,
		type: SAVE_CATELOG_VEHICLE_ID,
	};
};

export const saveAddressRef = (didPayload) => {
	return {
		addressDid: didPayload,
		type: SAVE_ADDRESS_DID_REF,
	};
};
export const getServiceDetails =
	(id = "", params = {}) =>
	async (dispatch) => {
		try {
			return await dispatch({
				[CALL_API]: {
					url: `/catalog/service/${id}`,
					method: "GET",
					types: [
						GET_SERVICE_DETAILS,
						GET_SERVICE_DETAILS_SUCCESS,
						GET_SERVICE_DETAILS_FAILED,
					],
					showLoader: true,
					params,
				},
			});
		} catch (error) {
			// alert(`${error}`);
			console.error("UInfo - 242", error);
		}
	};

export const getUserRefferalDetails = () => async (dispatch) => {
	try {
		return await dispatch({
			[CALL_API]: {
				url: `/user/referral`,
				method: "GET",
				types: [
					GET_USER_REFERAL_DETAILS,
					GET_USER_REFERAL_DETAILS_SUCCESS,
					GET_USER_REFERAL_DETAILS_FAILED,
				],
				showLoader: true,
				additionalData: {
					showError: false,
				},
			},
		});
	} catch (error) {
		// alert(`${error}`);
		console.error("UInfo - 265", error);
	}
};

export const saveUserRefferal = (refCode) => async (dispatch) => {
	try {
		return await dispatch({
			[CALL_API]: {
				url: `/user/referral`,
				method: "POST",
				types: [SAVE_USER_REFERAL, SAVE_USER_REFERAL_SUCCESS, SAVE_USER_REFERAL_FAILED],
				body: {
					referralCode: refCode,
				},
				showLoader: true,
				// showToast: true,
				// toastMessage: "Referral code applied successfully",
			},
		});
	} catch (error) {
		// alert(`${error}`);
		console.error("UInfo - 286", error);
	}
};

export const saveLocationPermissionStatus = (status) => {
	return {
		locStatus: status,
		type: SAVE_LOCATION_STATUS,
	};
};
export function logout() {
	return {
		type: LOGOUT_SUCCESS,
	};
}
